import React from 'react'

import {authFetched } from "actions/auth";
import {connect } from "react-redux";

class UserFullName extends React.Component{
  render(){
    return <span onClick={this.props.logout} style={{color:'inherit',textDecoration: 'none'}}>
      {this.props.children}
    </span>
    ;
  }
}
const state=()=>({})
const dispatch=(dispatch)=>({
  logout:()=>dispatch(authFetched({token:''}))
})
export default connect(state,dispatch)(UserFullName);



// WEBPACK FOOTER //
// ./src/views/Users/Logout.jsx